import React from 'react';
import PropTypes from 'prop-types';

/* IMPORTING SELECTION CARD STYLES */
import '../../assets/components/SelectionCard.scss'; 


export const SelectionCard = ({ cardIcon, cardIconColor, cardBorder, cardTitle, returnedType, cardDescription, cardBackgroundColor, selectionType }) => {

    return (
          <a className='selection-card-anchor' onClick={()=>selectionType(returnedType)}>
              <div className="selection-card" style={{'backgroundColor':`${cardBackgroundColor}`, 'border': `${cardBorder}`}}>
                <div className="selection-card-icon">
                    <i data-testid="card-icon" className={ cardIcon } style={{'color': `${cardIconColor}`}}></i>
                </div>
                <div className="selection-card-heading">
                    <h2 data-testid="card-title" className="card-title">{ cardTitle }</h2>
                    <p data-testid="card-details">{ cardDescription }</p>
                </div>
              </div>
            </a>
    );
};

SelectionCard.propTypes = {
    /* 
      icon used at the top of the selection card 
    */ 
      cardIcon: PropTypes.string.isRequired,
      cardIconColor: PropTypes.string.isRequired,
      cardBorder: PropTypes.string.isRequired,
    /* 
      title of the selection card 
    */ 
      cardTitle: PropTypes.string.isRequired,
    /* 
      returned type of the selection card 
    */ 
      returnedType: PropTypes.any,
    /* 
      description of the selection card 
    */ 
      cardDescription: PropTypes.string,
    /* 
      background color of the selection card 
    */ 
      cardBackgroundColor: PropTypes.string,
  }
  
  SelectionCard.defaultProps = {
    /*
     default value if cardIcon is not given
    */
     cardIcon: '/images/navabar/logo-placeholder.jpg',
    /*
     default value if cardTitle is not given
    */
     cardTitle: '',
  }
  